import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  return (
    <div className="flex justify-center mt-2">
      <div className="join">
        {Array.from({ length: totalPages }, (_, index) => index + 1).map(
          (page) => (
            <input
              key={page}
              className={`join-item btn btn-xs ${
                page === currentPage
                  ? 'btn-active'
                  : 'border border-slate-300 text-slate-500'
              }`}
              type="radio"
              name="options"
              aria-label={page}
              onClick={() => handlePageChange(page)}
            />
          )
        )}
      </div>
    </div>
  );
};

export default Pagination;
